import '@mdi/font/css/materialdesignicons.min.css'
import Vue from 'vue'
Vue.nextTick();
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
// @ts-ignore
import Fragment from 'vue-fragment'
import VueI18n from 'vue-i18n'
// @ts-ignore
import messages from './messages'
import VueRouter from 'vue-router'
import LoginMenu from './components/LoginMenu.vue'
import ModelMenu from './components/main/ModelMenu.vue'
import ModelLogo from './components/main/ModelLogo.vue'
import NotFound from './components/NotFound.vue'
import BearerToken from './components/BearerToken.vue'
import Main from './components/main/Main.vue'
import TopLeftMenu from './components/main/TopLeftMenu.vue'
import VuetifyConfirm from 'vuetify-confirm'

const AdminMain      = () => import(/* webpackChunkName: "admin" */          '@/components/admin/Main.vue');
const AddLogin       = () => import(/* webpackChunkName: "admin-logins" */   '@/components/admin/AddLogin.vue');
const Logins         = () => import(/* webpackChunkName: "admin-logins" */   '@/components/admin/Logins.vue');
const ScenariosList  = () => import(/* webpackChunkName: "admin-scenarios" */'@/components/admin/ScenariosList.vue');
const Models         = () => import(/* webpackChunkName: "admin-models" */   '@/components/admin/Models.vue');
const ModelDialog    = () => import(/* webpackChunkName: "admin-models" */   '@/components/admin/ModelDialog.vue');
const Groups         = () => import(/* webpackChunkName: "admin-groups" */   '@/components/admin/Groups.vue');
const AddGroup       = () => import(/* webpackChunkName: "admin-groups" */   '@/components/admin/AddGroup.vue');
const LogPage        = () => import(/* webpackChunkName: "admin-log" */      '@/components/admin/LogPage.vue');
const Roles          = () => import(/* webpackChunkName: "admin-roles" */    '@/components/admin/Roles.vue');
const RoleDialog     = () => import(/* webpackChunkName: "admin-roles" */    '@/components/admin/RoleDialog.vue');

Vue.use(VuetifyConfirm, {
    vuetify,
    buttonTrueText: 'Ja',
    buttonFalseText: 'Nee',
    //color: 'warning',
    color: null,
    icon: '',
    //title: 'Waarschuwing',
    width: 350,
    property: '$confirm'
})

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, RadialLinearScale, LineElement, LineController } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, RadialLinearScale, LineElement, LineController)
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ChartDataLabels);



Vue.prototype.Window = window;

Vue.use(Fragment.Plugin);
Vue.use(VueI18n);
Vue.use(VueRouter);

const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})

const defaultRoute = {
    path: '/',
    name: 'Default',
    components: {
        default: Main,
        loginMenu: LoginMenu,
        modelMenu: ModelMenu,
        modelLogo: ModelLogo,
        topLeftMenu: TopLeftMenu,

    }
}

const defaultRoute2 = {
    path: '/test',
    name: 'Test',
    components: {
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu,
    }
}


const adminRoute = {
    path: '/admin',
    name: 'Admin',
    components: {
        default: AdminMain,
        loginMenu: LoginMenu,
      

        topLeftMenu: TopLeftMenu
    }
}

const adminLogRoute = {
    path: '/admin/log',
    name: 'AdminLog',
    components: {
        default: AdminMain,
        adminLeft: LogPage,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}

const adminLoginsRoute = {
    path: '/admin/logins',
    name: 'AdminLogins',
    components: {
        default: AdminMain,
        adminLeft: Logins,
        adminRight: AddLogin,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}

const adminModelsRoute = {
    path: '/admin/models',
    name: 'AdminModels',
    components: {
        default: AdminMain,
        adminLeft: Models,
        adminRight: ModelDialog,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}


const adminGroupsRoute = {
    path: '/admin/groups',
    name: 'AdminGroups',
    components: {
        default: AdminMain,
        adminLeft: Groups,
        adminRight: AddGroup,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}

const adminRolesRoute = {
    path: '/admin/roles',
    name: 'AdminRoles',
    components: {
        default: AdminMain,
        adminLeft: Roles,
        adminRight: RoleDialog,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}

const adminScenarioStatusRoute = {
    path: '/admin/scenarioStatus',
    name: 'ScenarioStatus',
    components: {
        default: AdminMain,
        adminLeft: ScenariosList,
        loginMenu: LoginMenu,
        topLeftMenu: TopLeftMenu
    }
}

const notFoundRoute = {
    path: '*',
    components: {
        default: NotFound,
    }
}

export const router = new VueRouter({
    mode: 'history',
    routes: [
        defaultRoute, defaultRoute2, adminRoute, adminLogRoute, adminLoginsRoute, adminGroupsRoute, adminRolesRoute, adminModelsRoute, adminScenarioStatusRoute, notFoundRoute
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/admin')) {
        store.commit('main/SET_MODEL', null);
    }
    next();
})


import dateFilter from '@/filters/date.filter';
import timeFilter from '@/filters/time.filter';
import datetimeFilter from '@/filters/datetime.filter';
import currencyFilter from '@/filters/currency.filter';
import roundingFilter from '@/filters/rounding.filter';
import fixedNumberFilter from '@/filters/fixedNumber.filter';
import percentageFilter from '@/filters/percentage.filter';

Vue.filter('date', dateFilter);
Vue.filter('time', timeFilter);
Vue.filter('datetime', datetimeFilter);
Vue.filter('currency', currencyFilter);
Vue.filter('percentage', percentageFilter);
Vue.filter('rounding', roundingFilter);
Vue.filter('fixed', fixedNumberFilter);

Vue.config.productionTip = false


export default i18n;

new Vue({
    router,
    i18n,
    vuetify,
    store,
    
    render: h => h(App)
}).$mount('#app')
